import React, { useState, useEffect, useRef }  from 'react';
import { GetRequest } from 'components/common';
import { NumberWithUnitInput } from 'components/common';
import styles from 'components/show_drawing/redraw_form/_style.module.scss';
import MyEventListener from 'components/common/MyEventListener.jsx'
import Constants from 'components/show_drawing/Constants.jsx';
import OptionRowFloatInfr from 'components/layout/options/OptionRowFloatInfr.jsx'

const MaterialChooser = ({ id, unit, register, errors, drawing }) => {
  const custom = 'custom';
  const [materialId, setMaterialId] = useState(drawing.default_material_id);
  const [customMaterialThickness, setCustomMaterialThickness] = useState( unit == 'in' ? 0.0394 : 1 );
  const [materials, setMaterials] = useState( [] )
  const [changed, setChanged] = useState(false)
  const [askCustomMaterial, setAskCustomMaterial] = useState(false)
  const [materialLabelOverride, setMaterialLabelOverride] = useState(null)

  const labelRef = useRef();
  const emitLabelWidth = () => {
    emitEvent(Constants.drawing_input_label_width, { id: id, name: 'material_id', width: $(labelRef.current).width(), group: 'dropdowns' })
  }
  const adjustLabelWidthMsg = (e) => {
    if (e.detail.id == id && e.detail.name != 'material_id' && e.detail.group == 'dropdowns') {
      let myWidth = $(labelRef.current).width();
      let othersWidth = e.detail.width;
      if (othersWidth > myWidth) {
        $(labelRef.current).width(othersWidth);
      }
    }
  }

  const fetchMaterials = () => {
    // https://diecuttemplates.com.dev/materials/en/69005/mm
    GetRequest({
      url: `/materials/${window.locale}/${id}/${unit}`,
      callback: (data) => {
        setMaterials( (_prev) => data.values);
        setAskCustomMaterial( (_prev) => data.ask_custom_material)
        setMaterialId( () => data.default_material_id || data.values[0].materials[0].id )
        setMaterialLabelOverride( () => data.material_label_override )
      }
    })
  }

  const onChange = (e) => {
    setMaterialId(() => e.target.value);
  }

  const onDrawingOptionValueSetMsg = (msg) => {
    if(msg.detail.id == id && msg.detail.name == 'material_id') {
      emitEvent('addDebugEntry', { event: "[MaterialChooser] material changed", name: msg.detail.name, value: msg.detail.value})
      var value = msg.detail.value;
      var valueParts = value.split('|')
      if(valueParts.length == 2 && valueParts[0] == custom) {
        value = custom
        setCustomMaterialThickness( () => valueParts[1])
      }
      setMaterialId( () => value )
    }
  }

  const handleCustomMaterialChange = (e) => {
    setCustomMaterialThickness((_prev) => e.target.value)
  }

  const publishChangedEvent = () => {
    emitEvent('addDebugEntry', { event: "[OptionsCommon] SetValue event emitted", id: id, name: 'material_id', value: materialId, changed: changed} )
    emitEvent(Constants.drawing_option_change_completed, {id: id, name: 'material_id'})
    // Tell MenuTabs (a sibling component) the material changed, so the layouts
    // tab can drop "ve Üretim Maliyeti" live when a custom material is picked
    // (issue #5151).
    document.dispatchEvent(new CustomEvent('material_id_changed', { detail: { material_id: materialId } }))
  }

  // useEffect
  useEffect(fetchMaterials, [id, unit]);
  useEffect( () => {
    setCustomMaterialThickness( () =>  unit == 'in' ? 0.0394 : (unit == 'mm' ? 1 : "0+1/4")  )
  }, [unit]);

  useEffect( () => {
    if(drawing.default_material_id != undefined) {
      setMaterialId(() => drawing.default_material_id);
    }
  } , [drawing])

    useEffect(publishChangedEvent, [materialId, id, unit, drawing.default_material_id] )
  useEffect(emitLabelWidth, [labelRef.current])
  // useEffect

  MyEventListener([
    {
      key: Constants.drawing_option_set_value,
      callback: onDrawingOptionValueSetMsg
    },
    {
      key: Constants.drawing_input_label_width,
      callback: adjustLabelWidthMsg
    }
  ])

  return (
    <div className={styles.row}>
      <div className="input-group" style={{ width: '100%' }}>
        <span className={`d_input_add_on input-group-addon input-group-addon-${window.locale} ${styles.input_add_on}`} ref={labelRef}>
          { materialLabelOverride || t('drawing.material') }
        </span>
        <select name="material_id" value={materialId} onChange={onChange} className="form-control">
          {materials.map( (material) => (
            <optgroup label={material.group_name} key={material.group_name}>
            { material.materials.map((m) => <option value={m.id} key={m.id}>{m.name} </option>) }
          </optgroup> ) ) }

          {askCustomMaterial && (<optgroup key="ask_custom_material">
            <option value={custom}> { t('drawing.enter_custom_material') } </option>
          </optgroup>
          ) }

        </select>
      </div>

      {materialId == custom && (<div style={{ marginTop: "8px" }}>

        {unit == "infr" && <OptionRowFloatInfr
          item={{}}
          description=""
          name="custom_material_value"
          value={customMaterialThickness}
          unit={unit}
          abc_line=""
          onChange={handleCustomMaterialChange}
          onKeyUp={() => {}}
          wide={false}
          doNotLoadFromLocalStorage={true}
          disabled={false}
          decreaseNum={() => {}}
        />}

         {unit != "infr" && <NumberWithUnitInput
            name="custom_material_value"
            unit={unit}
            placeholder=""
            register={register}
            class_name="bla"
            errors={errors}
            validators={[]}
            value={customMaterialThickness}
            onChange={ handleCustomMaterialChange }
          />}

        </div>)}
    </div>
  )
}

export default MaterialChooser;
